import { render, staticRenderFns } from "./SubscribeWelcomeCta.vue?vue&type=template&id=047ec8c3&"
import script from "./SubscribeWelcomeCta.vue?vue&type=script&lang=js&"
export * from "./SubscribeWelcomeCta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports